import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['mA', 'A', 'kA'] as const;
const unit = z.literal('A').default('A');

const validator = AbstractMeasurement.nomMax
    .extend({
        unit,
    })
    .default({});

const nomValidator = AbstractMeasurement.nom
    .extend({
        unit,
    })
    .default({});

const valueValidator = AbstractMeasurement.value
    .extend({
        unit,
    })
    .default({});

const nomOptionalMinMaxValidator = AbstractMeasurement.nomOptionalMinMax.extend({
    unit,
});

export const Current = {
    validator,
    validators: {
        value: valueValidator,
        nom: nomValidator,
        nomOptionalMinMax: nomOptionalMinMaxValidator,
        unit,
    },
    units,
};

export type Current = z.infer<typeof validator>;
